import { createMuiTheme } from "@material-ui/core";
import { COLORS } from "../../utils/js/constants";

export default function manufacturerStyle() {
    return {
        containerManufacturer: {
            display: 'flex',
            overflow: 'auto',
            flexDirection: 'column',
            background: COLORS.grey,
        },
        title: {
            color: COLORS.lightYellow,
            display: 'flex',
            alignItems: 'center'
        },
        textPrimary: {
            color: COLORS.white,
            display: "flex",
            margin: 0,
            padding: 0
        },
        textSecondary: {
            color: COLORS.lightGrey,
            paddingLeft: "5px",
            display: "flex"
        }
    }
}

export const theme = createMuiTheme({
    overrides: {
        MuiListItemText: {
            multiline: {
                display: 'flex'
            }
        },
    }
});
